import type { UntypedFunction } from '@mnd-frontend/ts';
import { EmptyState, Symbols } from '@mnd-frontend/ui/publish/components';
import { useTranslation } from 'react-i18next';

const ContactListEmpty = ({
  onShowModal,
  noResults,
}: {
  onShowModal?: UntypedFunction;
  noResults?: boolean;
}) => {
  const [t] = useTranslation();

  return noResults ? (
    <EmptyState
      symbol={Symbols.NoResults}
      headline={t('contacts_contacts_no-results_title')}
      description={t('contacts_contacts_no-results_description')}
    />
  ) : (
    <EmptyState
      symbol={Symbols.NewUser}
      headline={t('contacts_contacts_empty_title')}
      action={t('contacts_add-button')}
      onClick={onShowModal}
    />
  );
};

export default ContactListEmpty;
